import React from "react";

import { useGlobalStore } from "../../services/GlobalStoreService/GlobalStoreHooks";
import { JOKI } from "../../JOKI";

import { Dropdown } from "selfly-ui-react";

import "./organization-dropdown.scss";

export default function OrganizationSelection(props) {
    const [value, setValue] = useGlobalStore("selectedOrganization", null);

   
    if (props.user === null || !Array.isArray(props.user.groups) || props.user.groups.length <= 1) {
        return null;
    }

    const orgOptions = props.user.groups.map(grp => {
       
        return { label: grp.Name, value: grp.Id };
    });

    orgOptions.unshift({ label: "All organizations", value: "_ALL_" });

    function update({ value, label }) {
        const newValue = value === "_ALL_" ? null : value;

        setValue(newValue);
        JOKI.broadcast({
            from: "React:OrganizationFilterDropDown",
            key: "changeGlobalFilter",
            body: {key: "organization", value: newValue, type: "string"},
        });
    }
    const selectedValue = value === null || value === 'null' || value === 'undefined' ? "_ALL_" : value;

    return (
        <div className="organization-dropdown-container">
            <Dropdown onChange={update} options={orgOptions} value={selectedValue} />
        </div>
    );
}
